var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectricBike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.18 7H19c2.8 0 5 2.2 5 4.99 0 2.81-2.45 5.13-5.25 5-2.34-.11-4.21-1.76-4.65-3.99H9.9c-.45 2.31-2.44 4-4.9 4-2.8 0-5-2.2-5-5s2.45-5.13 5.25-4.99C7.59 7.12 9.46 8.77 9.9 11h.67L8.75 6H7V4h5v2h-1.11l.36 1h4.81L14.6 3H12V1h2.6c.84 0 1.59.53 1.88 1.32L18.18 7ZM5 15c1.33 0 2.42-.83 2.82-2H5v-2h2.82C7.42 9.83 6.33 9 5 9c-1.68 0-3 1.32-3 3s1.32 3 3 3Zm7.7-4h1.4c.14-.75.46-1.42.9-2h-3.03l.73 2Zm3.3 1c0 1.68 1.32 3 3 3s3-1.32 3-3-1.32-3-3-3c-.017 0-.033.003-.048.006-.012.002-.023.004-.032.004l.97 2.67-1.88.68-.96-2.64C16.41 10.27 16 11.07 16 12Zm-9 8h4v-2l6 3h-4v2l-6-3Z",
  fill: "#1A1A1A"
})));
export default SvgElectricBike;